// extracted by mini-css-extract-plugin
export default {"list":"ExpressionList_list__v41Nl"};